import { render, staticRenderFns } from "./AverageDurations.vue?vue&type=template&id=343c2e8b"
import script from "./AverageDurations.vue?vue&type=script&lang=js"
export * from "./AverageDurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports